// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessibility_issue_block {
    border: 3px solid #D02B20 !important;
}

.accessibility_issue_text {
    background: #F4C3BE !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/utils/highlightDomElements/highlightStyles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".accessibility_issue_block {\n    border: 3px solid #D02B20 !important;\n}\n\n.accessibility_issue_text {\n    background: #F4C3BE !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
